export enum AppPackageStatus {
  PENDING = 'PENDING',
  READY = 'READY',
  NONE = 'NONE',
}
